import { formatTrayName } from "../../utils/formatTrayName"
import { ReactComponent as SalesPersonIcon } from "../../assets/icons/stock_icons/Sales_Person_Icon.svg"
import { ReactComponent as ClientIcon } from "../../assets/icons/stock_icons/Client_Icon.svg"
import { ReactComponent as PoIcon } from "../../assets/icons/stock_icons/PO_icon.svg"
import CustomTooltip from "../../components/ui/CustomTooltip"
import { Button } from "@mui/material"

const OccupiedTray = ({data, setOpenConfirmModal}) => {
  const handleReceive = () => {
    setOpenConfirmModal({open: true, data: {trayName: data?.trayName, salesPersonName: data?.salesPerson, id: data?._id}})
  }
  return (
    <div 
      style={{
        padding: "0.5vw 1vw",
        backgroundColor: "#E77B7B1A",
        borderRadius: "0.4vw",
        display: "flex",
        flexDirection: "column",
        gap: "0.8vw"
      }}
    >
      <div
        style={{
          width: "10.25vw",
          alignItems: "start",
          display: "flex",
          flexDirection: "column",
          gap: "0.4vw",
          fontFamily: "Poppins",
        }}>
        <p
          style={{
            whiteSpace: "nowrap",
            color: "#E77B7B",
            fontWeight: 500,
            fontSize: "0.8vw",
          }}>
          {formatTrayName(data.trayName)}
        </p>
        <div
          style={{
            display: "flex",
            gap: "0.4vw",
            alignItems: "center",
          }}
        >
          <span>
            <ClientIcon />
          </span>

          {data.clientName.length > 15 ? (
            <CustomTooltip title={data.clientName}>
              <p
                style={{
                  color: "white",
                  fontSize: "0.6vw",
                  cursor: "pointer",
                }}
              >
                {data.clientName.slice(0, 15)}...
              </p>
            </CustomTooltip>
          ) : (
            <p
              style={{
                color: "white",
                fontSize: "0.6vw",
                textTransform: "capitalize"
              }}
            >
              {data.clientName}
            </p>
          )}
        </div>
        <div
          style={{
            display: "flex",
            gap: "0.4vw",
            alignItems: "center",
          }}>
          <span>
            <SalesPersonIcon />
          </span>
          <p
            style={{
              color: "white",
              fontSize: "0.6vw",
              textTransform: "capitalize"
            }}>
            {data.salesPerson.length > 15
              ? `${data.salesPerson.slice(0, 15)}...`
              : data.salesPerson}
          </p>
        </div>
        {data.purchaseNo && (
          <div
            style={{
              display: "flex",
              gap: "0.4vw",
              alignItems: "center",
            }}>
            <span>
              <PoIcon />
            </span>
            <p
              style={{
                color: "white",
                fontSize: "0.6vw",
              }}>
              {data.purchaseNo}
            </p>
          </div>
        )}
      </div>

      <Button variant="outlined"
        sx={{
          fontFamily: "Poppins",
          fontWeight: 500,
          fontSize: "0.7vw",
          padding: "0.2vw 0.5vw",
          color: "#E77B7B",
          border: "1px solid #E77B7B",
          backgroundColor: "transparent",
          textTransform: "capitalize",
          "&:hover" : {
            backgroundColor: "#E77B7B",
            color: "#000"
          }
        }}
        onClick={handleReceive}
      >Receive</Button>

    </div>
  )
}

export default OccupiedTray
